const pad = (number) => String(number).padStart(2, "0");

const initKeuzehulp = (layout) => {
    const intro = layout.querySelector(".keuzehulp-intro");
    const tool = layout.querySelector(".keuzehulp-tool");
    const step = tool?.querySelector(".tool-step");
    const title = tool?.querySelector(".tool-title");
    const text = tool?.querySelector(".tool-text");
    const back = tool?.querySelector(".tool-back");
    if (!tool) return;

    const getForm = () => tool.querySelector("form[id^='gform_']");

    // GF keeps every page in the DOM: the current one is shown, pages skipped by conditional logic are marked hidden.
    const getState = () => {
        const pages = [...(getForm()?.querySelectorAll(".gform_page") ?? [])];
        const current = pages.find((page) => page.style.display !== "none");
        if (!current) return null;

        const visible = pages.filter((page) => page.dataset.conditionalLogic !== "hidden");
        const index = visible.indexOf(current) + 1;
        const answered = !!current.querySelector("input[type='radio']:checked");
        const hasNext = pages.indexOf(current) < pages.length - 1;
        // Before the question is answered the next pages are still unknown: count at least one more.
        const total = !answered && hasNext ? Math.max(visible.length, index + 1) : visible.length;

        return { current, index, total };
    };

    const update = () => {
        const state = getState();
        tool.classList.toggle("is-done", !state);
        if (!state) return;

        const legend = state.current.querySelector(".gfield--type-radio .gfield_label");
        const description = state.current.querySelector(".gfield--type-radio .gfield_description:not(.validation_message)");

        if (title && legend) {
            const clone = legend.cloneNode(true);
            clone.querySelectorAll(".gfield_required").forEach((node) => node.remove());
            title.textContent = clone.textContent.trim();
        }
        if (text) text.textContent = description?.textContent.trim() ?? "";

        if (step) {
            const label = (layout.dataset.stepLabel || "").replace("%1$s", state.index).replace("%2$s", state.total);
            step.innerHTML = `<span aria-hidden="true"><strong>${pad(state.index)}</strong> / ${pad(state.total)}</span>`;
            if (label) {
                const hidden = document.createElement("span");
                hidden.className = "screen-reader-text";
                hidden.textContent = label;
                step.append(hidden);
            }
        }
    };

    const start = () => {
        layout.classList.add("is-started");
        if (intro) intro.hidden = true;
        tool.hidden = false;
        update();
        getState()?.current.querySelector("input[type='radio']")?.focus();
    };

    const stop = () => {
        layout.classList.remove("is-started");
        tool.hidden = true;
        if (intro) {
            intro.hidden = false;
            intro.querySelector(".keuzehulp-start")?.focus();
        }
    };

    layout.querySelector(".keuzehulp-start")?.addEventListener("click", start);

    function goBack() {
        const previous = getState()?.current.querySelector(".gform_previous_button");
        if (previous) previous.click();
        else stop();
    }

    back?.addEventListener("click", goBack);

    // "Vorige" in the form footer is rendered by GF (gform-keuzehulp.php) and re-rendered per page: delegate.
    tool.addEventListener("click", (event) => {
        if (event.target.closest(".tool-back.is-footer")) goBack();
    });

    // GF re-evaluates its page logic on the same change; read the result a frame later.
    tool.addEventListener("change", () => requestAnimationFrame(update));

    const formId = getForm()?.id.replace("gform_", "");
    const onRender = (id) => {
        if (String(id) !== String(formId)) return;
        update();
        if (layout.classList.contains("is-started")) {
            getState()?.current.querySelector("input[type='radio']")?.focus({ preventScroll: true });
        }
    };

    document.addEventListener("gform/post_render", (event) => onRender(event.detail?.formId));
    window.jQuery?.(document).on("gform_post_render", (event, id) => onRender(id));

    update();
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.keuzehulp-layout").forEach(initKeuzehulp);
});
